import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['navigation', 'burgerButton', 'pushMenu', 'notification', 'announcement', 'sticky'];
  static values = {
    openClass: { type: String, default: '--open' }, 
    lockBodyClass: { type: String, default: '--locked' },
  }

  connect() {
    this.lastScroll = 0;
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll);
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  toggleMobileMenu() {
    this.toggleMenuState();
    this.toggleBodyLock();
  }

  toggleMenuState() {
    this.burgerButtonTarget.classList.toggle(this.openClassValue);
    this.pushMenuTarget.classList.toggle(this.openClassValue);
    this.navigationTarget.classList.toggle(this.openClassValue);
  }

  handleScroll() {
    const currentScroll = window.pageYOffset;

    if (this.isMenuOpen() || currentScroll <= 65) {
      this.showNavigation();
    } else if (currentScroll > this.lastScroll) {
      this.hideNavigation();
    } else {
      this.showNavigation();
    }

    this.lastScroll = currentScroll;
  }

  isMenuOpen() {
    return this.navigationTarget.classList.contains(this.openClassValue);
  }

  showNavigation() {
    requestAnimationFrame(() => {
      this.navigationTarget.style.transform = 'translateY(0)';
      if (this.hasNotificationTarget) {
        this.notificationTarget.style.transform = 'translate(-50%, 0)';
      }
      this.announcementTargets.forEach(target => {
        target.style.transform = 'translateY(0)';
      });
      this.stickyTargets.forEach(target => {
        target.style.transform = 'translateY(0)';
      });
    });
  }

  hideNavigation() {
    const navHeight = this.navigationTarget.offsetHeight;
    requestAnimationFrame(() => {
      this.navigationTarget.style.transform = 'translateY(-100%)';
      if (this.hasNotificationTarget) {
        this.notificationTarget.style.transform = 'translate(-50%, -100%)';
      }
      this.announcementTargets.forEach(target => {
        target.style.transform = 'translateY(-200%)';
      });
      this.stickyTargets.forEach(target => {
        target.style.transform = `translateY(-${navHeight}px)`;
      });
    });
  }

  toggleBodyLock() {
    document.body.classList.toggle(this.lockBodyClassValue, this.isMenuOpen())
  }
}
